import { combineReducers } from 'redux'
import { combineEpics } from 'redux-observable'

import * as bootstrapEpic from './bootstrap/epic'
import bootstrapReducer from './bootstrap/reducer'
import * as conversationActions from './conversation/actions'
import * as conversationEpic from './conversation/epic'
import conversationReducer from './conversation/reducer'
import conversationLogReducer from './conversationLog/reducer'
import * as endUserEpic from './endUser/epic'
import endUserReducer from './endUser/reducer'
import * as messageEpic from './message/epic'
import messageReducer from './message/reducer'
import * as modalEpic from './modal/epic'
import modalReducer from './modal/reducer'
import * as notificationsEpic from './notifications/epic'
import notificationsReducer from './notifications/reducer'
import orgReducer from './org/reducer'
import * as performanceTrackingEpic from './performanceTracking/epic'
import playbooksReducer from './playbooks/reducer'
import * as routerEpic from './router/epic'
import routingAuditLogReducer from './routingAuditLog/reducer'
import rulesReducer from './rules/reducer'
import * as sidebarEpic from './sidebar/epic'
import sidebarReducer from './sidebar/reducer'
import * as socketEpic from './socket/epic'
import socketReducer from './socket/reducer'
import teamsReducer from './teams/reducer'
import * as toastNotificationEpic from './toastNotification/epic'
import toastNotificationReducer from './toastNotification/reducer'
import * as trackingEpic from './tracking/epic'
import * as userEpic from './user/epic'
import userReducer from './user/reducer'
import viewReducer from './view/reducer'
import * as webSocketEpic from './websocket/epic'

export const rootReducer = () =>
  combineReducers({
    conversation: conversationReducer,
    conversationLog: conversationLogReducer,
    user: userReducer,
    notifications: notificationsReducer,
    message: messageReducer,
    endUser: endUserReducer,
    socket: socketReducer,
    org: orgReducer,
    view: viewReducer,
    modal: modalReducer,
    bootstrap: bootstrapReducer,
    sidebar: sidebarReducer,
    toastNotification: toastNotificationReducer,
    teams: teamsReducer,
    rules: rulesReducer,
    playbooks: playbooksReducer,
    routingAuditLog: routingAuditLogReducer,
  })

export const rendererActions = {
  conversation: conversationActions,
}

export const rootEpic = combineEpics(
  ...Object.values(conversationEpic),
  ...Object.values(userEpic),
  ...Object.values(messageEpic),
  ...Object.values(socketEpic),
  ...Object.values(toastNotificationEpic),
  ...Object.values(endUserEpic),
  ...Object.values(notificationsEpic),
  ...Object.values(trackingEpic),
  ...Object.values(bootstrapEpic),
  ...Object.values(modalEpic),
  ...Object.values(routerEpic),
  ...Object.values(sidebarEpic),
  ...Object.values(webSocketEpic),
  ...Object.values(performanceTrackingEpic)
)
